<template>
  <md-content class="md-scrollbar">
    <div v-if="product" class="product md-layout">
      <div class="md-xsmall-size-100">
        <md-card-media class="media">
          <img
            class="media-img"
            v-touch:swipe="imageSwipeHandler"
            v-on:click="imageClickHandler"
            :src="image"
            :alt="product.name"
          />
        </md-card-media>
      </div>
      <div class="md-xsmall-size-100 custom-desc">
        <md-card-header class="custom-header">
          <div class="md-subhead">
            Заказ: {{ product.orderNumber }}
            <span v-if="product.cartNumber > 0">
              (К{{ product.cartNumber }})
            </span>
          </div>
          <div class="md-title">{{ product.name }}</div>
          <hr />
          <div class="md-subhead">{{ product.description }}</div>
        </md-card-header>

        <md-card-content class="custom-content">
          <p class="custom-p">
            <span>Артикул:</span>
            <strong>{{ product.article }}</strong>
          </p>
          <p class="custom-p">
            <span>Поставщик:</span>
            <strong>{{ product.vendor }}</strong>
          </p>
          <p class="custom-p">
            <span>Артикул поставщика:</span>
            <strong>{{ product.vendor_code }}</strong>
          </p>
          <p class="custom-p">
            <span>Размер:</span>
            <strong>{{ product.size }}</strong>
          </p>
          <p class="custom-p">
            <span>Цвет:</span>
            <strong>{{ product.color }}</strong>
          </p>
          <p class="custom-p">
            <span>Вложить:</span>
            <strong>{{ product.quantity }} / {{ product.assembled }}</strong>
          </p>
          <p class="custom-p">
            <span>На складе:</span>
            <strong>{{ product.quantity_on_storage }}</strong>
          </p>
          <p class="custom-p">
            <span>В куче:</span>
            <strong>{{ product.quantity_on_bunch }}</strong>
          </p>
          <p class="custom-p">
            <span>
              Где лежит:
              <strong class="placeButtonText">
                {{ product.additional_info }}
              </strong>
            </span>
          </p>
          <p
            v-if="product.reminder && !product.quantity_on_storage"
            class="custom-p"
          >
            <span>
              Напоминание:
              <strong class="reminderButtonText">{{ product.reminder }}</strong>
            </span>
          </p>
          <p class="custom-check">
            <!-- <md-icon>radio_button_unchecked</md-icon> -->
            <a style="cursor: pointer" v-on:click.prevent="addFastReplacement">
              <span>Быстрая замена</span>
              <span v-if="product.hasReplacement">(предложена)</span>
            </a>
            |
            <router-link
              :to="{
                name: 'replacementForArticle',
                params: {
                  orderId: product.orderId,
                  orderNumber: product.orderNumber,
                  cartNumber: product.cartNumber,
                  article: product.article,
                  size: product.size,
                },
              }"
            >
              <span>Передложить замену</span>
              <span v-if="product.hasReplacement">(предложена)</span>
            </router-link>
          </p>
          <!-- <p class="custom-check">
            <md-icon>radio_button_checked</md-icon>
            <router-link
              :to="{
                name: 'replacementForArticle',
                params: {
                  orderId: product.orderId,
                  cartNumber: product.cartNumber,
                  article: product.article,
                  size: product.size,
                },
              }"
            >
              <span>Передложить замену</span>
              <span v-if="product.hasReplacement">(предложена)</span>
            </router-link>
          </p> -->
        </md-card-content>
      </div>
    </div>
    <!-- <div class="md-layout-item md-size-100" style="">
      <div
        v-if="product.barcodes.length"
        class="md-layout-item"
        style="padding: 10px"
      >
        <div>
          <md-card
            v-for="barcode in product.barcodes"
            :key="barcode"
            style="box-shadow: none"
          >
            <md-card-content class="custom-content">
              <barcode
                tag="img"
                :value="barcode"
                :options="{ displayValue: true, format: 'EAN13' }"
              ></barcode>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div> -->
  </md-content>
</template>

<script>
  export default {
    name: "ExtendedShowProduct",
    data: () => ({
      image: null,
      comments: [
        {
          label: "Замена",
          value: "Замена",
        },
        {
          label: "По фото",
          value: "По фото",
        },
      ],
      loading: false,
      error: null,
    }),
    computed: {
      product() {
        return this.$store.state.product.item;
      },
      holder() {
        return this.$store.state.holder.item;
      },
    },
    watch: {
      product() {
        this.image = this.holder;

        const path = this.product.images.big[0];
        new Promise((resolve, reject) => {
          const img = new Image();

          img.onload = () => resolve();

          img.onerror = () => reject();

          img.src = path;
        })
          .then(() => {
            this.image = path;
          })
          .catch((error) => {
            console.error(error);
            this.$store.commit("messages/setMessage", {
              type: "warning",
              code: "Ой вей!",
              message: "Картинка к товару не была загружена",
            });
          });
      },
    },
    mounted() {
      this.image = this.holder;
    },
    methods: {
      addFastReplacement() {
        this.loading = true;
        this.$axios
          .post("/replacement_add_fast", {
            orderId: this.product.orderId,
            orderNumber: this.product.orderNumber,
            cartNumber: this.product.cartNumber,
            articleFrom: this.product.article,
            sizeFrom: this.product.size,
          })
          .then(() => {
            this.$store.commit(
              "orders/setProductHasReplacementTrue",
              this.product
            );

            this.$store.commit("messages/setMessage", {
              type: "success",
              code: "О да!",
              message: "Запрос на замену успешно отправлен",
            });
          })
          .finally(() => {
            this.loading = false;
          });
      },
      imageClickHandler() {
        this.imageSwipeHandler("right");
      },
      imageSwipeHandler(direction) {
        const index = this.product.images.big.indexOf(this.image);

        if (direction === "right") {
          if (index - 1 >= 0) {
            this.image = this.product.images.big[index - 1];
          } else {
            this.image = this.product.images.big[
              this.product.images.big.length - 1
            ];
          }
        }

        if (direction === "left") {
          if (index + 1 <= this.product.images.big.length - 1) {
            this.image = this.product.images.big[index + 1];
          } else {
            this.image = this.product.images.big[0];
          }
        }
      },
    },
  };
</script>

<style>
  .custom-content {
    padding-bottom: 0 !important;
  }
</style>

<style lang="scss" scoped>
  .product {
    // @media (max-width: 800px) {
    flex-wrap: nowrap;
    // }

    @media (max-width: 530px) {
      flex-wrap: wrap;
    }
  }

  .custom-p {
    margin: 10px 5px;
    @media (max-width: 800px) {
      margin: 0;
    }
  }

  .custom-check {
    @media (max-width: 800px) {
      margin: 4px 0;
    }
  }

  .custom-header {
    @media (max-width: 800px) {
      padding: 8px 16px;
    }
  }

  .my-md-icon {
    font-size: 40px !important;
  }
  .placeButtonText {
    color: #458dfa !important;
  }
  .reminderButtonText {
    color: #ff5252 !important;
  }

  .media-img {
    max-height: 100vh;
    width: auto;
  }

  .custom-content {
    padding-bottom: 0;
    // text-align: center;
  }

  .custom-desc {
    flex: 1 1;
  }
</style>
